export default __webpack_public_path__ + "static-front/media/SerfIcon.9395fba1.svg";